import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
const renderBold = (text, children)=>{
    return text.bold ? /*#__PURE__*/ _jsx("strong", {
        children: children
    }) : children;
};
const renderItalic = (text, children)=>{
    return text.italic ? /*#__PURE__*/ _jsx("em", {
        children: children
    }) : children;
};
const renderUnderline = (text, children)=>{
    return text.underline ? /*#__PURE__*/ _jsx("u", {
        children: children
    }) : children;
};
const renderStrikethrough = (text, children)=>{
    return text.strikethrough ? /*#__PURE__*/ _jsx("s", {
        children: children
    }) : children;
};
export const Leaf = (param)=>{
    let { attributes, leaf, children } = param;
    const elementToRender = renderStrikethrough(leaf, renderUnderline(leaf, renderItalic(leaf, renderBold(leaf, children))));
    return /*#__PURE__*/ _jsx("span", _object_spread_props(_object_spread({}, attributes), {
        children: elementToRender
    }));
};
